import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Separator, TextButton } from 'styles/styles';

import Policies from './Policies';
import {
  CenteredContainer,
  CopyrightContainer,
  HeaderContainer,
  TermContainer,
  TermContent,
  TermsContainer,
  TermTitle,
  TitleTerms,
} from './styles';
import Terms from './Terms';

interface LegalAgreementsProps {
  title: string;
}

type LegalAgreement = {
  title: string;
  content: string;
};

export const LegalAgreementsMap: { [key: string]: LegalAgreement[] } = {
  terms_conditions: Terms,
  privacy_policy: Policies,
};

function ul(chunks: React.ReactNode) {
  return (
    <ul>{chunks}</ul>
  );
}

function li(chunks: React.ReactNode) {
  return (
    <li>{chunks}</li>
  );
}

function b(chunks: React.ReactNode) {
  return (
    <b>{chunks}</b>
  );
}

function mailto(chunks: React.ReactNode) {
  return (
    <TextButton color="secondary" href={`mailto:${chunks}`}>{chunks}</TextButton>
  );
}

function LegalAgreements(props: LegalAgreementsProps) {
  const { title } = props;
  const items = LegalAgreementsMap[title];
  const currentYear = new Date().getFullYear();

  return (
    <CenteredContainer>
      <HeaderContainer>
        <TitleTerms>
          <FormattedMessage id={title} />
        </TitleTerms>
      </HeaderContainer>
      <TermsContainer>
        {items.map((item) => (
          <TermContainer key={item.title}>
            <TermTitle>
              <FormattedMessage id={item.title} />
            </TermTitle>
            <TermContent>
              <FormattedMessage
                id={item.content}
                values={{
                  ul,
                  li,
                  b,
                  mailto,
                }}
              />
            </TermContent>
          </TermContainer>
        ))}
      </TermsContainer>
      <CopyrightContainer>
        <Separator />
        <FormattedMessage id="terms_conditions_copyright" values={{ year: currentYear }} />
      </CopyrightContainer>
    </CenteredContainer>
  );
}

export default LegalAgreements;
